export const routePrefix = {
  postReaction: 'post-reaction',
};
